/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Error_Not_FoundInputs */



/**
* | output |
* | --- |
* | "That licence key wasn't found. Check it against your purchase email." |
*
* @param {License_Error_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_error_not_found = /** @type {((inputs?: License_Error_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Error_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette clé de licence est introuvable. Vérifiez-la dans l'e-mail de votre achat.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Lizenzschlüssel wurde nicht gefunden. Vergleichen Sie ihn mit Ihrer Kaufbestätigung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiave di licenza non trovata. Controllala nell'email di acquisto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Лицензионный ключ не найден. Сверьте его с письмом о покупке.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontró esa clave de licencia. Compárala con el correo de tu compra.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到该许可证密钥。请对照购买邮件检查。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このライセンスキーは見つかりません。購入時のメールと照らし合わせてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह लाइसेंस कुंजी नहीं मिली। इसे अपनी खरीद ईमेल से मिलाएँ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Essa chave de licença não foi encontrada. Confirme-a no email da compra.")
	return /** @type {LocalizedString} */ ("That licence key wasn't found. Check it against your purchase email.")
});